import FormDialog from '../Dialog/FormDialog';
import {BasketForm} from '../Form/BasketForm';
import {Basket} from '../../types';
import {useFormSubmit} from '@alchemy/api';
import {postBasket} from '../../api/basket';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {StackedModalProps, useModals} from '@alchemy/navigation';
import {useDirtyFormPrompt} from '@alchemy/phrasea-framework';
import {useBasketStore} from '../../store/basketStore';

type Props = {
    onCreate?: (data: Basket) => void;
} & StackedModalProps;

export default function CreateBasket({onCreate, ...modalProps}: Props) {
    const {t} = useTranslation();
    const {closeModal} = useModals();
    const addBasket = useBasketStore(state => state.addBasket);

    const usedFormSubmit = useFormSubmit<Basket>({
        defaultValues: {
            name: '',
        },
        onSubmit: async (data: Basket) => {
            return await postBasket(data);
        },
        onSuccess: data => {
            toast.success(
                t('form.basket_create.success', 'Basket created!') as string
            );
            addBasket(data);
            closeModal();

            onCreate?.(data);
        },
    });

    const {submitting, remoteErrors, forbidNavigation} = usedFormSubmit;
    useDirtyFormPrompt(forbidNavigation, modalProps.modalIndex);
    const formId = 'create-basket';

    return (
        <FormDialog
            {...modalProps}
            title={t('form.basket_create.title', 'Create Basket')}
            formId={formId}
            loading={submitting}
            errors={remoteErrors}
        >
            <BasketForm formId={formId} usedFormSubmit={usedFormSubmit} />
        </FormDialog>
    );
}
